module.exports = __webpack_public_path__ + "img/baner_www_01.529b21aa.jpg";